import { Link } from 'react-router-dom';

import Tooltip from '@/ui/components/Tooltip';

interface StaffIndicatorsProps {
  isCredentialed?: boolean;
  isSelfPay?: boolean;
  credentialingLinkTo?: string;
  hasConflictOfInterest?: boolean;
  isMostRecent?: boolean;
}

export const StaffIndicators = ({
  isCredentialed,
  isSelfPay,
  credentialingLinkTo,
  hasConflictOfInterest,
  isMostRecent
}: StaffIndicatorsProps) => (
  <>
    {!isCredentialed && !isSelfPay && (
      <Tooltip tooltipContent="Not Credentialed">
        {credentialingLinkTo ? (
          <Link to={credentialingLinkTo} target="_blank" rel="noreferrer">
            <span className="px-2 text-md">⚠️</span>
          </Link>
        ) : (
          <span className="px-2 text-md">⚠️</span>
        )}
      </Tooltip>
    )}
    {hasConflictOfInterest && (
      <Tooltip tooltipContent="Conflict of Interest">
        <span className="px-2 text-md">🚫</span>
      </Tooltip>
    )}
    {isMostRecent && (
      <Tooltip tooltipContent="Assigned Provider">
        <span className="px-2 text-md">💚</span>
      </Tooltip>
    )}
  </>
);
